import script from "./SearchPageFiltersModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchPageFiltersModal.vue?vue&type=script&setup=true&lang=ts"

import "./SearchPageFiltersModal.vue?vue&type=style&index=0&id=55208a81&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55208a81"]])

export default __exports__